module.exports = __webpack_public_path__ + "static/media/course_coupon_banner.c559343d.jpg";